import styled from "styled-components";

export const Container = styled.div`
  width: 100%;

  .data-box {
    max-width: 1440px;
    margin: 0 auto;
  }
`;
